import moment from 'moment';

export function sortEventsByDate (events = []) {
    const futureEventsPerDate = {};
    events.forEach(event => {
        const dateYYYYMMDD = moment(event.schedule_start).format('YYYY-MM-DD');
        if (!futureEventsPerDate[dateYYYYMMDD]) {
            futureEventsPerDate[dateYYYYMMDD] = [];
        }
        futureEventsPerDate[dateYYYYMMDD].push(event);
    });

    const nextScheduledEvents = Object.keys(futureEventsPerDate).map(dateString => {
        const title = moment(dateString).format('dddd, MMMM DD');
        return {
            title,
            events: futureEventsPerDate[dateString]
        };
    });

    return nextScheduledEvents ? nextScheduledEvents.sort((a, b) => (new Date(a.schedule_start) < new Date(b.schedule_start)) ? -1 : 1) : [];
}
